import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../../Command";
import { LoginRequest } from "./LoginRequest";
import { LoginResponse } from "./LoginResponse";

const ENDPOINT = "/Auth/Login";

export class LoginCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: LoginRequest;

    constructor(payload: LoginRequest) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<LoginResponse> {
        var res = await this.executeCommand(this.payload);
        return new LoginResponse(res);
    }
}
